module.exports = __webpack_public_path__ + "img/premium_02.376cdcdd.jpg";